module.exports = __webpack_public_path__ + "img/bronze.e0a3699a.png";